import MarketingLayout from "@/components/MarketingLayout";
import SEOPageNew from "@/pages/newsite/SEOPageNew";

export default function MetaAdsLibraryAltPage() {
  return (
    <MarketingLayout>
      <SEOPageNew />
    </MarketingLayout>
  );
}
